import script from "./MobileFootbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileFootbar.vue?vue&type=script&setup=true&lang=ts"

import "./MobileFootbar.vue?vue&type=style&index=0&id=1eaf803a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eaf803a"]])

export default __exports__